/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { SagaIterator } from 'redux-saga';
import { all, call, takeLatest } from 'redux-saga/effects';
import { postReservationAdapter } from '../../adapters/ReservationsAdapter';
import { ReservationTypes } from './ReservationActionTypes';

export function* createReservationSaga(action: any): SagaIterator {
  yield call(postReservationAdapter, action.payload);
}

export function* watchReservationsAsyncActions(): SagaIterator {
  yield all([takeLatest(ReservationTypes.CREATE_RESERVATION, createReservationSaga)]);
}
